var exports = {
  "Kk": "VoiceSettingsMenus.module__icon___RGRnbU",
  "XK": "VoiceSettingsMenus.module__leadingActionLabel___RGRnbU",
  "CS": "VoiceSettingsMenus.module__inputLevelItem___RGRnbU",
  "lL": "VoiceSettingsMenus.module__inputLevelLabel___RGRnbU",
  "_A": "VoiceSettingsMenus.module__inputLevelMeter___RGRnbU",
};

module.exports = exports;
